var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61.4 91.2-8.8-8.8 26.2-26.2H0V43.8h78.8L52.6 17.6l8.8-8.8 36.8 36.8c1.2 1.2 1.8 2.7 1.8 4.4s-.7 3.2-1.8 4.4L61.4 91.2z"
  })));
};
export default SvgArrow;